import React, { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export default function ScrollToTopButton() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > window.innerHeight * 0.6);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollUp = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <button
      onClick={scrollUp}
      aria-label="Scroll to top"
      className={`fixed bottom-8 right-8 z-50 w-14 h-14 rounded-full bg-[#5C2018] text-[#F5EFE6] shadow-2xl flex items-center justify-center transition-all duration-500 hover:bg-[#B8893C] hover:scale-110 ${
        show ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-6 pointer-events-none"
      }`}
    >
      <ArrowUp size={20} />
      <span className="absolute -inset-1 rounded-full border border-[#B8893C]/40 animate-ping" style={{ animationDuration: "2.5s" }}></span>
    </button>
  );
}
